import FWarehouse from "@/models/f-warehouse";


export const warehouseModule = {
    namespace: true,
    state: {
        itemModifiedWarehouse: new FWarehouse(),
        formModeWarehouse: String,
    },
    actions:{
        updateItemModifiedWarehouse({commit}, payload) {
            commit('mutateItemModifiedWarehouse', payload)
        },
        updateFormModeWarehouse({commit}, payload){
            commit('mutateFormModeWarehouse', payload)
        },
    },
    mutations:{
        mutateItemModifiedWarehouse(state, payLoad) {
          state.itemModifiedWarehouse = payLoad
        },
        mutateFormModeWarehouse(state, payLoad){
            state.formModeWarehouse = payLoad
        },
    }

}